import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ReportProgress} from '../models/report.model';
import 'rxjs/add/operator/do';
import {ApiConnectService} from './api-connect.service';
import {
  DAY_OFF_PATH,
  HTTP_RESPONSE_OBSERVE,
  QUERY_SEPARATOR,
  REPORT_DATE_QUERY_KEY,
  REPORT_PROGRESS_HEADER,
  REPORT_PATH
} from './user-report.constants';
import {PendingReportProgress} from './user-report.types';

@Injectable()
export class UserReportService {
  private pendingReportProgress: PendingReportProgress;

  constructor(
    private http: HttpClient,
    private apiURL: ApiConnectService
  ) {
  }

  trackNextReportProgress(
    progressId: string,
    resultHandler: (successful: boolean) => void
  ): void {
    this.pendingReportProgress = {id: progressId, resultHandler: resultHandler};
  }

  cancelNextReportProgress(): void {
    this.pendingReportProgress = null;
  }

  getReportByUserId(from: string, to: string, id: string) {
    const progress = this.takePendingReportProgress();
    let headers = new HttpHeaders({'from': from, 'to': to});
    if (progress) {
      headers = headers.set(REPORT_PROGRESS_HEADER, progress.id);
    }

    const request = this.http.get(
      this.apiURL.getUserReport + id + REPORT_PATH,
      {headers: headers, observe: HTTP_RESPONSE_OBSERVE}
    );
    return progress ? request.do(
      () => progress.resultHandler(true),
      () => progress.resultHandler(false)
    ) : request;
  }

  getReportProgress(progressId: string) {
    return this.http.get<ReportProgress>(this.apiURL.getReportProgress + progressId);
  }

  getReportByUserIdOff(from: string, to: string, id: string) {
    return this.http.post(
      this.apiURL.getUserReportOff + id + QUERY_SEPARATOR
        + new HttpParams().set(REPORT_DATE_QUERY_KEY, from),
      {observe: HTTP_RESPONSE_OBSERVE}
    );
  }

  getReportByGroupIdOff(groupId: string, date: string) {
    return this.http.post(
      this.apiURL.getGroupReportOff + groupId + DAY_OFF_PATH
        + new HttpParams().set(REPORT_DATE_QUERY_KEY, date),
      null,
      {observe: HTTP_RESPONSE_OBSERVE}
    );
  }

  private takePendingReportProgress(): PendingReportProgress {
    const progress = this.pendingReportProgress;
    this.pendingReportProgress = null;
    return progress;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/user-report.service.ts